import type { VFC } from 'react';
import { FormattedMessage } from 'react-intl';

import type { LocalizationItem } from '~/constants';
import { localizationFallbackItems } from '~/constants';

interface LocalizedTextProps {
  localizationItem: LocalizationItem;
}

export const LocalizedText: VFC<LocalizedTextProps> = ({ localizationItem }) => (
  <FormattedMessage
    id={localizationItem}
    defaultMessage={localizationFallbackItems[localizationItem]}
  />
);
